import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { UserInterfaceContextProviders } from "./userInterfaceContext";

import Me from "./pages/me";
function App() {
  return (
    <UserInterfaceContextProviders>
      <Router basename="/">
        <Routes>
          <Route path="/" element={<Me />} />
          {/* <Route path="/DesktopHome" element={<DesktopHome />} /> */}
        </Routes>
      </Router>
    </UserInterfaceContextProviders>
  );
}

export default App;
